import { setPropertySchema } from '../../utils/helpers';
import { Buttons } from './buttons';

export class Input extends Buttons {
  dressInputs = async () => {
    // get all inputs in form
    const inputs = this.form.querySelectorAll('input');

    // for each input dress by type
    inputs.forEach((x) => {
      const type = x.getAttribute('type');
      const isBlocked = this.isBlocked(x);

      switch (type) {
        case 'button':
          return this.dressButton(x, true);
        case 'checkbox':
          return this.dressCheckboxItem(x, isBlocked);
        case 'radio':
          return this.dressRadioItem(x, isBlocked);
        default:
          return this.dressInputText(x, isBlocked);
      }
    });
  };

  dressInputText = (input, blocked) => {
    // get input properties
    const name = this.getName(input);
    const type = input.getAttribute('type');
    const value = input.value;

    // set properties on element
    input.setAttribute('data-fs-element', 'input');
    name && input.setAttribute('data-fs-input-name', name.toLowerCase());
    type && input.setAttribute('data-fs-input-type', type);

    if (value) {
      input.setAttribute('data-fs-input-value', !blocked ? value : 'blocked');
      !blocked && this.updateButton(name ? name : 'input', value);
    }

    // add event listener to update the dom with data values
    input.addEventListener('input', () => {
      // add input value property
      input.setAttribute('data-fs-input-value', !blocked ? input.value : 'blocked');

      // add value to button
      !blocked && this.updateButton(name ? name : 'input', input.value);

      // update property schema
      setPropertySchema(input);
    });

    // set the property schema
    setPropertySchema(input);
  };

  dressCheckboxItem = (input, blocked) => {
    /**
     * Possible Properties
     * -------------------
     *  data-fs-element = checkbox-item
     *  data-fs-checkbox-selected = true | false | <BLOCKED>
     *  data-fs-checkbox-item-name = <NAME>
     *  data-fs-checkbox-item-value = <VALUE> | <BLOCKED>
     *  data-fs-input-type = checkbox-item
     */

    // TODO: update how name is acquired
    // get name of input and set on element
    const name = input.getAttribute('name');
    // get type and set on element
    const type = input.getAttribute('type');
    // get value and set on element
    const value = input.getAttribute('value');
    // check for selected attribute on element
    const selected = input.getAttribute('data-fs-checkbox-item-selected');

    // set properties on element
    input.setAttribute('data-fs-element', 'checkbox-item');
    // set name
    name && input.setAttribute('data-fs-checkbox-item-name', name.toLowerCase());
    // set type
    type && input.setAttribute('data-fs-input-type', type);
    // set value
    value && input.setAttribute('data-fs-checkbox-item-value', !blocked ? value : 'blocked');

    // if selected is null set property as false
    if (selected === null && !blocked) {
      input.setAttribute('data-fs-checkbox-item-selected', 'false');
    } else if (blocked) {
      input.setAttribute('data-fs-checkbox-item-selected', 'blocked');
    }

    if (!blocked) {
      // add event listener to update the dom when selected
      input.addEventListener('click', () => {
        // grab current selection
        const curselected = input.getAttribute('data-fs-checkbox-item-selected');

        // get selected
        const selected = curselected === 'false' ? 'true' : curselected === 'true' ? 'false' : 'false';

        // update selected on property
        input.setAttribute('data-fs-checkbox-item-selected', selected);

        // update button
        this.updateButton(`${name}_${value}`, selected);

        // update property schema
        setPropertySchema(input);
      });
    }

    // set the property schema
    setPropertySchema(input);
  };

  dressRadioItem = (input, blocked) => {
    /**
     * Possible Properties
     * -------------------
     *  data-fs-element = radio-item
     *  data-fs-raidio-item-selected = true | false
     *  data-fs-raidio-item-name = <NAME>
     *  data-fs-raidio-item-value = <VALUE>
     *  data-fs-input-type = raidio
     */

    // get name of input and set on element
    const name = input.getAttribute('name');
    // get type and set on element
    const type = input.getAttribute('type');
    // get value and set on element
    const value = input.getAttribute('value');
    // check for selected attribute on element
    const selected = input.getAttribute('data-fs-radio-item-selected');

    // set properties on element
    input.setAttribute('data-fs-element', 'radio-item');
    // TODO: update how name is acquired
    name && input.setAttribute('data-fs-radio-item-name', name.toLowerCase());
    value && input.setAttribute('data-fs-radio-item-value', !blocked ? value : 'blocked');
    type && input.setAttribute('data-fs-input-type', type);

    // if selected is null set property as false
    if (selected === null && !blocked) {
      input.setAttribute('data-fs-radio-item-selected', 'false');
    } else if (blocked) {
      input.setAttribute('data-fs-radio-item-selected', 'blocked');
    }

    if (!blocked) {
      // add event listener to update the dom when selected
      input.addEventListener('click', () => {
        // grab current selection
        const curselected = input.getAttribute('data-fs-radio-item-selected');

        // get selected
        const selected = curselected === 'true' ? 'false' : 'true';

        // update selected on property
        input.setAttribute('data-fs-radio-item-selected', selected);

        // update button
        if (name) {
          this.updateButton(name, selected);
        } else if (value) {
          this.updateButton(value, selected);
        }

        // update property schema
        setPropertySchema(input);
      });

      // set the property schema
      setPropertySchema(input);
    }
  };
}
